import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Service Portal",
    component: () => import("../components/pages/ServicePortal.vue"),
    meta: {},
  },
  {
    path: "/Login",
    name: "Login ",
    component: () => import("../components/pages/LogIn.vue"),
    meta: {},
  },
  {
    path: "/ChangePassword",
    name: "ChangePassword",
    component: () => import("../components/pages/ForgotPassword.vue"),
    meta: {},
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../components/pages/Home.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/case-service-request",
    name: "Service Request",
    component: () => import("../components/pages/ServiceRequest.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/service-calls",
    name: "Service Calls",
    component: () => import("../components/pages/ServiceCalls.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/project-jobs",
    name: "Project Jobs",
    component: () => import("../components/pages/ProjectJobs.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/invoices",
    name: "Invoices",
    component: () => import("../components/pages/Invoice.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/service-jobs",
    name: "Jobs Information",
    component: () => import("../components/pages/ServiceJob.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/service-jobs1",
    name: "Jobs",
    component: () => import("../components/pages/Jobbkup.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/fs-scheduling",
    name: "Field Service Scheduling",
    component: () => import("../components/pages/JobSchedule.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/equip-scheduling",
    name: "Transport Scheduling",
    component: () => import("../components/pages/EquipSchedule.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/booking-schedule",
    name: "Booking Scheduling",
    component: () => import("../components/pages/BookingSchedule.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/service-contracts",
    name: "Service Contracts",
    component: () => import("../components/pages/Contracts.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/order-management",
    name: "Order Management",
    component: () => import("../components/pages/Orders.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/shipment-management",
    name: "Shipment Management",
    component: () => import("../components/pages/Shipment.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/quote-management",
    name: "Quote Management",
    component: () => import("../components/pages/Quote.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/rma-management",
    name: "RMA Management",
    component: () => import("../components/pages/RMA.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/inventory-management",
    name: "Inventory Management",
    component: () => import("../components/pages/Inventory.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/memo",
    name: "Memo",
    component: () => import("../components/pages/Memo.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/user-management",
    name: "User Management",
    component: () => import("../components/pages/User.vue"),
    meta: { layout: "home" },
  },
  {
    path: "/field-help",
    name: "Field Help",
    component: () => import("../components/pages/FieldHelp.vue"),
    meta: { layout: "home" },
  },
  {
    path: "*",
    name: "404",
    component: () => import("../components/pages/NotFoundPage.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  // base: process.env.BASE_URL,
  routes,
});

export default router;
